import { Collapse as AntCollapse } from "antd";
import upArrowIcon from "@assets/icons/up_arrow.svg";
import downArrowIcon from "@assets/icons/down_arrow.svg";

export default function Collapse({
  label,
  labelClasses,
  collapsePlaceholderLabel,
  collapseContent,
  activeKey,
  setActiveKey,
  collapseKey = 1,
  containerClasses,
  collapseContainerClasses,
  collapsePlaceholderLabelClasses,
  collapseContentClasses,
  multiple = false,
}) {
  return (
    <div>
      {label && (
        <label
          className={labelClasses || "text-primary-main font-teachers text-sm"}
        >
          {label}
        </label>
      )}
      <div
        className={`${containerClasses} !border rounded-lg !border-primary-tint-placeholder overflow-hidden `}
      >
        <AntCollapse
          activeKey={activeKey}
          className={`transition-all duration-200 [&_.ant-collapse-header]:bg-[#F0FDF4] [&_.ant-collapse-header]:!p-3.5 ${collapseContainerClasses}`}
          rootClassName="!bg-transparent"
          bordered={false}
          expandIconPosition="end"
          expandIcon={({ isActive }) =>
            isActive ? (
              <img alt="up arrow" src={upArrowIcon} className="!h-2.5 !w-3 select-none" />
            ) : (
              <img
                alt="down arrow"
                src={downArrowIcon}
                className="!h-2.5 !w-3 select-none"
              />
            )
          }
          onChange={() => {
            if (multiple) {
              setActiveKey((prev) =>
                prev.includes(collapseKey)
                  ? prev.filter((key) => key !== collapseKey)
                  : [...prev, collapseKey]
              );
            } else {
              setActiveKey((prev) =>
                prev && prev.includes(collapseKey) ? null : [collapseKey]
              );
            }
          }}
          size="small"
          items={[
            {
              key: collapseKey,
              label: (
                <span
                  className={`!text-text-main select-none font-semibold text-sm ${collapsePlaceholderLabelClasses}`}
                >
                  {collapsePlaceholderLabel}
                </span>
              ),
              className: "border-none !bg-transparent",
              children: (
                <div className={`pt-2 ${collapseContentClasses}`}>
                  {collapseContent}
                </div>
              ),
            },
          ]}
        />
      </div>
    </div>
  );
}
